import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
  humanize,
  fmtDate,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "pending_review", label: "Pending Review" },
  { value: "resolved", label: "Resolved" },
  { value: "refunded", label: "Refunded" },
  { value: "rejected", label: "Rejected" },
];

const columns = [
  { key: "id", label: "Dispute ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
  { key: "order_id", label: "Order", render: (r) => <span className="font-mono text-xs">{r.order_id}</span> },
  { key: "issue_type", label: "Issue", render: (r) => humanize(r.issue_type) },
  { key: "customer_name", label: "Customer" },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "created_at", label: "Opened", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.created_at)}</span> },
];

export default function Disputes() {
  const { data, mocked, loading, refreshing, reload } = useResource("/disputes", "disputes");
  return (
    <div data-testid="admin-disputes-page">
      <PageHeader title="Disputes" subtitle="Customer issues awaiting resolution." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="disputes-table"
        exportName="disputes"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by dispute, order, customer..."
        searchKeys={["id", "order_id", "customer_name", "issue_type"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        detailTitle={(r) => `Dispute ${r.id}`}
        detailSubtitle={(r) => `${humanize(r.issue_type)} \u2022 ${r.customer_name}`}
      />
    </div>
  );
}
